module.exports = __webpack_public_path__ + "img/Ray-iQ-High_on_laptop.5d20346d.jpg";